import { Stack, styled } from '@mui/material';

export const TableSearchBarRoot = styled(Stack)(({ theme: { spacing, palette } }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  padding: spacing(1, 2),
  borderBottom: '1px solid',
  borderBottomColor: palette.divider,
  '&[data-ds-pagination="true"]': {
    flexWrap: 'wrap',
    gap: spacing(2),
    '& > .ds-pagination': {
      flex: '1 1 50%',
      minWidth: 0,
    },
  },
}));
